import biblop from "./biblop.png";
import bouftou from "./bouftou.png";
import dragonborn from "./skyrim.png";
import pin from "./pin.png";

const markerIcons = { pin, dragonborn, biblop, bouftou };
export default markerIcons;
